import { BrowserRouter, Route, Routes } from "react-router";

import Clarity from "@microsoft/clarity";

import { useValidateToken } from "../hooks";
import { RedirectHome } from "../ui/components";
import OnboardingModal from "../ui/components/global/_onboardingModal";
import pages from "../ui/pages";

function AuthBootstrap() {
  useValidateToken();
  return null;
}

Clarity.init("vrolp1b0qa");

const Router = () => {
  return (
    <BrowserRouter>
      <AuthBootstrap />
      <Routes>
        <Route element={<RedirectHome />} path="/" />
        {pages.map(({ Element, path = null, ...props }) => (
          <Route
            element={<Element key={path || props.id} {...props} />}
            path={path || `/${props.id}`}
          />
        ))}
      </Routes>
      <OnboardingModal />
    </BrowserRouter>
  );
};

export default Router;
